import type { ReactNode } from 'react';
import type { TFunction } from 'i18next';
import { CourtesyVehicleCard } from '@/components/workorders/courtesy';
import type { CourtesyWorkOrderRef } from '@/components/workorders/courtesy';
export interface WorkOrderDetailCardSection {
  title: string;
  summary: string;
  content: ReactNode;
}

/** Courtesy-car card section for the work-order detail layout (PF-120). */
export function courtesyWorkOrderCardSection(
  workOrder: CourtesyWorkOrderRef,
  t: TFunction<'workorders'>,
): WorkOrderDetailCardSection {
  return {
    title: t('courtesy.cardTitle'),
    summary: t('courtesy.cardSummary'),
    content: <CourtesyVehicleCard workOrder={workOrder} />,
  };
}
/** PF-083 approval card exports for the work-order detail layout (`approval` card in WorkOrderDetailContent). */

export {
  WorkOrderApprovalCard,
  SignatureRequiredNotice,
  describeWorkOrderSignatureRequiredError,
  isWorkOrderSignatureRequiredError,
  openWorkOrderApprovalCard,
  WORK_ORDER_APPROVAL_CARD_ELEMENT_ID,
  WORK_ORDER_SIGNATURE_REQUIRED_CODE,
} from '@/components/workorders/signature';
export type { WorkOrderApprovalCardProps } from '@/components/workorders/signature';

export const APPROVAL_DETAIL_CARD_ID = 'approval' as const;
